import {    CARGAR_ASIENTOCONT, SELECCIONAR_CUENTACONTABLE, 
            CARGAR_INDICADORCC, CARGAR_CATALOGOCUENTAS,
            CARGAR_CTACONTABLE, ESTABLECER_CTACONTABLE, CARGAR_PLANESCONTABLES } from '../actions/contabilidad/actionTypes';

const contabilidadReducer = (state = {
    asientoContable: {},
    cuentasContables_sel: [],
    indicadorCCosto: {},
    catalogoCuentas: [],
    cuentaContable: {},
    planesContables: []
}, action) => {
    switch(action.type){
        case CARGAR_ASIENTOCONT:
            return { ...state, asientoContable: action.data };
        case SELECCIONAR_CUENTACONTABLE:
            if (state.cuentasContables_sel[action.ctaContable.key]===undefined){
                return {...state, cuentasContables_sel: state.cuentasContables_sel.concat(action.ctaContable)};
            }else{
                return {...state, cuentasContables_sel: actualizarCuentaSeleccionada(state.cuentasContables_sel, action.ctaContable)};
            }
        case CARGAR_INDICADORCC:
            return {...state, indicadorCCosto: action.indicadorCCosto};
        case CARGAR_CATALOGOCUENTAS:
            return {...state, catalogoCuentas: action.data };
        case CARGAR_CTACONTABLE:
        case ESTABLECER_CTACONTABLE:
            return {...state, cuentaContable: action.data };
        case CARGAR_PLANESCONTABLES:
            return {...state, planesContables: action.data };
        default:
            return state;
    }
};

const actualizarCuentaSeleccionada = (cuentasSel, cuentaContable) =>{
    return  cuentasSel.map((item)=>{
        if (item.key!==cuentaContable.key){
            return item;
        }else{
            return cuentaContable;
        }
    });
}

export default contabilidadReducer;